@if (showMenubar()) {
	<app-menubar></app-menubar>
}

<horizon-toast></horizon-toast>
<router-outlet></router-outlet>
<bcu-spinner></bcu-spinner>
<bcu-modal></bcu-modal>

@if (!chromeless()) {
	<horizon-app-version-footer backgroundColor="#F6FAFF" strokeColor="#E9EEF2"></horizon-app-version-footer>
}
